import { render, staticRenderFns } from "./ProductVariations.vue?vue&type=template&id=1b782cf3&scoped=true&lang=html"
import script from "./ProductVariations.vue?vue&type=script&lang=js"
export * from "./ProductVariations.vue?vue&type=script&lang=js"
import style0 from "./ProductVariations.vue?vue&type=style&index=0&id=1b782cf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b782cf3",
  null
  
)

export default component.exports